import { render, staticRenderFns } from "./ReservationDialog.vue?vue&type=template&id=0f94e182&scoped=true&"
import script from "./ReservationDialog.vue?vue&type=script&lang=ts&"
export * from "./ReservationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReservationDialog.vue?vue&type=style&index=1&id=0f94e182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94e182",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardText,VChip,VFlex,VForm,VIcon,VLayout,VSelect})
